import React, { useState } from "react";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import "../styles/FloatingLabelInput.css";

const FloatingLabelInput = ({
  label,
  type,
  value,
  onChange,
  errorMessage,
  ...props
}) => {
  const [isFocused, setFocused] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const isPassword = type === "password";
  const inputType = isPassword ? (showPassword ? "text" : "password") : type;

  const handleFocus = () => {
    setFocused(true);
  };

  const handleBlur = () => {
    setFocused(false);
  };

  return (
    <div
      className={`input-box ${isFocused ? "focused" : ""} ${
        errorMessage ? "error" : ""
      }`}
    >
      <label
        className={`floating-label ${isFocused || (value !== undefined && value !== "") ? "float" : ""}`}
      >
        {label}
      </label>
      <div className="input-field-wrapper">
        <input
          type={inputType}
          value={value}
          onChange={onChange}
          onFocus={handleFocus}
          onBlur={handleBlur}
          aria-label={label}
          style={isPassword ? { paddingRight: "2.5rem" } : {}}
          {...props}
        />
        {isPassword && (
          <button
            type="button"
            className="password-toggle-btn"
            onClick={() => setShowPassword(!showPassword)}
            tabIndex="-1"
            title={showPassword ? "Hide password" : "Show password"}
          >
            {showPassword ? <FaEyeSlash size={16} /> : <FaEye size={16} />}
          </button>
        )}
      </div>
      {errorMessage && <div className="error-message">{errorMessage}</div>}
    </div>
  );
};

export default FloatingLabelInput;
